import React from "react";
import { useTranslation } from "react-i18next";
import {
    DetailsBlock,
    DetailsHeader,
    DetailsRow,
    Label,
    Value,
} from "src/components/ContinueDealerOffer/Pages/ReviewPage";
import { localizeCurrencyWithDecimals } from "src/utils";

interface Props {
    tradeAllowance: number;
    tradeBalance: number;
    tradeCashOut: number;
}

const TradeIn = ({ tradeAllowance, tradeBalance, tradeCashOut }: Props) => {
    const { t } = useTranslation();

    if (!tradeAllowance) {
        return null;
    }

    return (
        <DetailsBlock>
            <DetailsHeader>{t("DealerOffer.ContinueDealerOffer.ReviewPage.TradeIn.Header")}</DetailsHeader>

            <DetailsRow>
                <Label>{t("DealerOffer.ContinueDealerOffer.ReviewPage.TradeIn.Allowance")}</Label>
                <Value>{localizeCurrencyWithDecimals(tradeAllowance)}</Value>
            </DetailsRow>

            {!!tradeBalance && (
                <DetailsRow>
                    <Label>{t("DealerOffer.ContinueDealerOffer.ReviewPage.TradeIn.Balance")}</Label>
                    <Value>{localizeCurrencyWithDecimals(tradeBalance)}</Value>
                </DetailsRow>
            )}

            {tradeCashOut !== tradeAllowance && (
                <DetailsRow>
                    <Label>{t("DealerOffer.ContinueDealerOffer.ReviewPage.TradeIn.CashOut")}</Label>
                    <Value>{localizeCurrencyWithDecimals(tradeCashOut)}</Value>
                </DetailsRow>
            )}
        </DetailsBlock>
    );
};

export default TradeIn;
